var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',{attrs:{"size":"small","min":_vm.min,"max":_vm.max},on:{"change":_vm.changeNum},model:{value:(_vm.inputNum),callback:function ($$v) {_vm.inputNum=$$v},expression:"inputNum"}})}
var staticRenderFns = []

export { render, staticRenderFns }